/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-param-reassign */
import * as React from 'react';
import { useIsMobile } from '../../../hooks';
import { windowExists } from '../../Utils';
export var useScrollToAnchor = function (ref, isMobile, isDefaultTriggered) {
    if (isDefaultTriggered === void 0) { isDefaultTriggered = false; }
    /** Example Usage:
     *  https://<host>/myaccount/proxtraprogramdetails?scrollTrigger=pro_xtra_FAQ
     */
    React.useEffect(function () {
        var _a, _b;
        var triggered = false;
        if (windowExists() && ref) {
            var triggerID = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.id;
            var urlParams = new URLSearchParams(window.location.search);
            var parsedParam = urlParams.get('scrollTrigger') || '';
            if (triggerID === parsedParam)
                triggered = true;
        }
        if (isMobile && (isDefaultTriggered || triggered))
            (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth' });
    }, [isMobile]);
};
var AnchorElement = function (_a) {
    var id = _a.id, anchorRef = _a.anchorRef;
    return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
    React.createElement("a", { id: id, ref: anchorRef }));
};
export var ScrollToAnchorRef = function (_a) {
    var id = _a.id, isDefaultTriggered = _a.isDefaultTriggered;
    var isMobile = useIsMobile().isMobile;
    var elementRef = React.useRef(null);
    useScrollToAnchor(elementRef, isMobile, isDefaultTriggered);
    return React.createElement(AnchorElement, { id: id || '', anchorRef: elementRef });
};
var scrollSmoothAndSlow = function (pos, time) {
    var currentPos = window.scrollY;
    var start = null;
    if (time == null)
        time = 500;
    pos = +pos;
    time = +time;
    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        var progress = currentTime - start;
        if (currentPos < pos)
            window.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos);
        else
            window.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time);
        if (progress < time)
            window.requestAnimationFrame(step);
        else
            window.scrollTo(0, pos);
    });
};
export var scrollToAnchorPosition = function (_a) {
    var id = _a.id, top = _a.top, speed = _a.speed;
    if (!windowExists())
        return;
    var anchor = document === null || document === void 0 ? void 0 : document.querySelector("#".concat(id));
    if (anchor)
        top = (anchor === null || anchor === void 0 ? void 0 : anchor.offsetTop) + 250;
    var pos = top || 0;
    var time = speed === 0 ? 0 : speed || 1000;
    scrollSmoothAndSlow(pos, time);
};
